import sortBy from "lodash/sortBy";

const SelectDropdownHelper = {
  getSelectDropdownMapping: ({ data = [], keyAttr = "iso" }) => {
    const dataMapping = {};
    data.forEach((dataObj) => (dataMapping[dataObj[keyAttr]] = { ...dataObj }));
    return dataMapping;
  },
  getSelectDropdownOptions: ({
    data = [],
    textAttr = "abbr",
    valueAttr = "abbr",
    filterAttrs = ["abbr", "name"],
    otherAttrs = [],
    getText,
  }) => {
    let dataOptions = [];
    data.forEach((dataObj) => {
      const text = typeof getText === "function" ? getText(dataObj) : dataObj[textAttr];
      const name = dataObj[textAttr];
      const value = dataObj[valueAttr];
      const filterAttrsData = [...filterAttrs, ...otherAttrs].reduce(
        (acc, curr) => ({ ...acc, [curr]: dataObj[curr] }),
        {}
      );
      dataOptions = [...dataOptions, { text, value, name, ...filterAttrsData }];
    });
    dataOptions = sortBy(dataOptions, "name");
    return dataOptions;
  },
};

export const { getSelectDropdownMapping, getSelectDropdownOptions } = SelectDropdownHelper;

export const getCountryData = (countries, options = {}) => {
  const { countryOptionParams = {} } = options;
  const countryMapping = getSelectDropdownMapping({
    data: countries,
    keyAttr: "iso",
  });

  const countryOptions = getSelectDropdownOptions({
    data: countries,
    textAttr: "name",
    valueAttr: "iso",
    filterAttrs: ["iso", "name"],
    otherAttrs: ["dialCode"],
    ...countryOptionParams,
  });

  return { countryMapping, countryOptions };
};
